var exports = {
  "k": "xaf9ae18d--d95e3e--container",
  "K": "xaf9ae18d--d95e3e--icon",
};

module.exports = exports;
